import styled from "styled-components";

export const GeneralStyle = styled.div`
  background-color: ${({ theme }) => theme.background.light};
  height: 100%;
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
`;

export const ContentContainer = styled.div`
  margin-left: 1.5rem;
  width: 96.5%;
`;
